import type { LayoutCandidates } from 'components/Keyboard/types';
import { MayBe } from 'types/common';

class CandidateCache {
  private static cache: LayoutCandidates = {};

  static get(input: string): MayBe<string> {
    return this.cache[input];
  }

  static set(input: string, candidates: string[]): void {
    const existing = this.cache[input];
    this.cache[input] = existing ? `${existing} ${candidates.join(' ')}` : candidates.join(' ');
  }

  static setCandidates(input: LayoutCandidates = {}): void {
    this.cache = { ...this.cache, ...input };
  }

  static getAll(): LayoutCandidates {
    return this.cache;
  }

  static clear(input?: string) {
    if (input) {
      delete this.cache[input];
    } else {
      this.cache = {};
    }
  }
}

export default CandidateCache;